import { FC } from "react";

const Footer: FC = () => {
  const getYear = () => {
    const date = new Date();
    return date.getFullYear();
  };
  return (
    <footer className='flex flex-col gap-y-3 bg-accent py-4 text-center font-semibold'>
      <p className=''>© 2021 - {getYear()} ley0x</p>
      <div className="flex gap-x-2 items-center mx-auto flex-wrap justify-center">
        <img src="/mastodon.svg" alt="Mastodon" className="h-6 w-6" />
        <a rel="me" href="https://infosec.exchange/@ley0x">@ley0x@infosec.exchange</a>
      </div>
    </footer>
  );
};

export default Footer;
